






































import Vue from "vue";
import { Component } from "vue-property-decorator";
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxEditing,
  DxPopup,
  DxForm,
} from "devextreme-vue/data-grid";
import { DxItem } from "devextreme-vue/form";
import mantenimiento_permisoModule from "@/store/modules/mantenimiento_permiso-module";
import { mantenimiento_permiso } from "@/shared/dtos/mantenimiento_permiso";

@Component({
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxEditing,
    DxPopup,
    DxForm,
    DxItem,
  },
})
export default class TableEditing extends Vue {
  mounted() {
    this.refreshData();
  }

  get permisos() {
    return mantenimiento_permisoModule.mantenimiento_permisos;
  }

  refreshData() {
    mantenimiento_permisoModule.getmantenimiento_permisos();
  }

  crearPermiso(e: any) {
    var permiso = new mantenimiento_permiso(e.data);
    permiso.id = 0; // Aseguramos que el ID sea 0 para una nueva inserción
    mantenimiento_permisoModule
      .guardarmantenimiento_permiso(permiso)
      .then(() => this.refreshData())
      .catch((err) => console.error("Error al crear permiso:", err));
  }

  actualizarPermiso(e: any) {
    const permiso = new mantenimiento_permiso(e.data);
    mantenimiento_permisoModule
      .modificarmantenimiento_permiso(permiso)
      .then(() => this.refreshData())
      .catch((err) => console.error("Error al actualizar permiso:", err));
  }

  eliminarPermiso(e: any) {
    const permiso = new mantenimiento_permiso(e.data);
    mantenimiento_permisoModule
      .eliminarmantenimiento_permiso(permiso)
      .then(() => this.refreshData())
      .catch((err) => console.error("Error al eliminar permiso:", err));
  }
}
